export default function ({ $axios, redirect, store, route }) {
  if (!Object.keys(store.state.user).length) {
    if (route.path !== '/login/' && route.path !== '/reset-password/' && route.path !== '/reset-email/') {
      redirect('/login/')
    }
  } else {
    if (route.path === '/login/') {
      redirect('/')
    }
    if (route.path === '/announces/' && store.state.user.role_id < 10) {
      redirect('/')
    }
  }
}